<template>
  <div class="centered-container">
    <md-content class="md-elevation-3">
    </md-content>
		<DefaultTags />
  </div>
</template>

<script>
import firebase from 'firebase'
import { config } from '../config'
import DefaultTags from '../components/Dashboard/DefaultTags'

export default {
	name: 'dashboard',
	components: {
		DefaultTags,
  },
};
</script>

<style lang="scss">
.divider-margin {
  margin: 20px 0px;
}
</style>

